import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { WordPreview, type MyWord } from '@entities/Word';
import { trackEvent } from '@shared/analytics';
import { buildUnitPath } from '@shared/config';
import { ChevronRightIcon, Modal } from '@shared/ui';

/**
 * Подробности слова (владелец 2026-10-28: «попап удобный снизу с примером, смыслом и тд»): на телефоне — шторка
 * снизу, на компьютере — окно по центру. Внутри — карточка слова, как в модуле, со смыслом под примером; только
 * просмотр — править и убирать слово можно в модуле, куда ведёт кнопка внизу.
 */
export function WordSheet({ word, onClose }: { word: MyWord | null; onClose: () => void }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const posLabel = (pos: string) => t(`moduleDetail.words.pos.${pos}`, pos);
  return (
    <Modal
      open={!!word}
      onClose={onClose}
      placement="sheet"
      tight
      kicker={word ? t('words.sheet.kicker', { module: word.module.title }) : undefined}
    >
      {word && (
        <>
          {/* Вид карточки — как в нижнем листе модуля (стили WordBrowser.css под .wb-sheet-body). */}
          <div className="wb-sheet-body">
            <WordPreview key={word.stateId} word={word} posLabel={posLabel} showDefinition />
          </div>
          <button
            type="button"
            onClick={() => {
              trackEvent('words_word_module_opened');
              onClose();
              navigate(buildUnitPath(word.module.id));
            }}
            className="inline-flex min-h-[44px] w-full items-center justify-center gap-1.5 rounded-pill px-5 text-[15px] font-semibold text-fg shadow-[inset_0_0_0_1px_#3a3a40] transition-colors hover:bg-elev focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
          >
            <span className="min-w-0 truncate">{t('words.sheet.openModule')}</span>
            <ChevronRightIcon aria-hidden className="h-4 w-4 flex-none" />
          </button>
        </>
      )}
    </Modal>
  );
}
